import { render, staticRenderFns } from "./PlanAnualPage.vue?vue&type=template&id=736c35d6"
import script from "./PlanAnualPage.vue?vue&type=script&lang=js"
export * from "./PlanAnualPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports